// /frontend/src/pages/Policies.jsx
import React from "react";

const Policies = () => (
  <div className="p-8 text-center">
    <h2 className="text-2xl font-bold mb-2">Policies</h2>
    <p className="text-gray-600">Coming Soon…</p>
  </div>
);

export default Policies;
